import React, { useEffect, useState } from "react";
import IconButton from "@material-ui/core/IconButton";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import Delete from "@material-ui/icons/Delete";
import FileCopy from "@material-ui/icons/FileCopy";
import { useTranslation } from "react-i18next";
import { useSetRecoilState } from 'recoil';
import { alertState } from '../../../../../../../recoil-store/recoil-state';
import OpenInNew from "@material-ui/icons/OpenInNew";
// import EditIcon from '@material-ui/icons/Edit';
import CutIcon from '../../../../../../../assets/icons/actionIcons/cut-icon.svg';
import CopyIcon from '../../../../../../../assets/icons/actionIcons/copy-icon.svg';
import PasteIcon from '../../../../../../../assets/icons/actionIcons/paste-icon.svg';
import PasteInsideIcon from '../../../../../../../assets/icons/actionIcons/paste-inside-icon.svg';
import DeleteIcon from '../../../../../../../assets/icons/actionIcons/delete-icon.svg';
import OpenTabIcon from '../../../../../../../assets/icons/actionIcons/open-tab-icon.svg';
import EditIcon from '../../../../../../../assets/icons/actionIcons/edit-icon.svg';
import { findChildDesktopActionById } from "../../../../../../../helpers/helper";


const options = {
    Cut: <img alt="Cut Icon" src={CutIcon} style={{ fontSize: "18px", marginRight: "5px" }} />,
    Copy: <img alt="Copy Icon" src={CopyIcon} style={{ fontSize: "18px", marginRight: "5px" }} />,
    Paste: <img alt="Paste Icon" src={PasteIcon} style={{ fontSize: "18px", marginRight: "5px" }} />,
    "Paste Inside": <img alt="Paste Inside Icon" src={PasteInsideIcon} style={{ fontSize: "18px", marginRight: "5px" }} />,
    Delete: <img alt="Delete Icon" src={DeleteIcon} style={{ fontSize: "18px", marginRight: "5px" }} />,
    OpenTab: <img alt="Open Tab Icon" src={OpenTabIcon} style={{ fontSize: "18px", marginRight: "5px" }} />,
    Rename: <img alt="Rename Icon" src={EditIcon} style={{ fontSize: "18px", marginRight: "5px" }} />,
    // Disable: <img alt="Rename Icon" src={EditIcon} style={{ fontSize: "18px", marginRight: "5px" }} />,
};

function OptionsMenu(props) {
    const { t } = useTranslation();
    const { index, isCondition, detailTabs, setDetailTabs, item, setDialog } = props;
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const setAlert = useSetRecoilState(alertState);

    useEffect(() => {
        if (anchorEl === undefined) {
            const n = item?.library_label?.includes('CUSTOM') ? item.action_name : t(`CONTENT.LIBRARY.${item.libraryName}.ACTION.${item.name}`);
            props.options.rename(n);
        }
    }, [anchorEl])

    const handleClick = (e) => {
        if (!e) e = window.event;
        e.cancelBubble = true;
        if (e.stopPropagation) e.stopPropagation();
        setAnchorEl(e.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleCloseRename = () => {
        setAnchorEl(undefined);
    };

    const menu = async (option, e) => {
        if (option === "Delete") {
            e.stopPropagation();
            props.options.delete(props.id, item.actionName === 'IF' ? props.condition : undefined);
        } else if (option === "Copy") {
            setAlert(alert => ({ ...alert, show: true, message: t("MESSAGES.AUTOMS.AUTOM-COPIED"), severity: 'success' }))
            props.options.copy();
        } else if (option === "Cut") {
            e.stopPropagation();
            props.options.cut();
            if (item.library_label === "DESKTOPACTIONS") {
                return setAlert(alert => ({ ...alert, show: true, message: t('MESSAGES.AUTOMS.RULE.DESKTOP-ACTIONS-CANNOT-BE-COPY'), severity: 'error' }));
            }
            if (item.children && item.children.length) {
                const childDesktopAction = findChildDesktopActionById(item.children)
                if (childDesktopAction?.actionName) {
                    return setAlert(alert => ({ ...alert, show: true, message: t('MESSAGES.AUTOMS.RULE.GROUPABLE-ACTIONS-CANNOT-BE-COPY-WHILE-HAS-CHILD-DESKTOP-ACTIONS'), severity: 'error' }));
                }
            }
            props.options.delete(true, item.actionName === 'IF' ? props.condition : undefined);
        } else if (option === "Paste") {
            e.stopPropagation();
            props.options.paste(undefined, undefined, false);
        } else if (option === 'OpenTab') {
            if (setDetailTabs) {
                // function isTabExists(e, item) {
                //     for (const iterator of e) {
                //         if (iterator.item.id === item.id) {
                //             return false;
                //         }
                //     }
                //     return true;
                // }

                // if (isTabExists(detailTabs, props.condition ? props.condition : item)) {
                //     setDialog({ from: props.condition ? props.condition : "group", item: item });
                // }
                setDialog({ from: props.condition ? props.condition : "group", item: item });

            }
        } else if (option === "Debugging") {
            // debugging
            let elem = document.getElementById("debug-icon" + index);
            if (elem !== null && elem !== undefined) {
                elem.style = "visibility:hidden";
            }
        } else if (option === "Paste Inside") {
            e.stopPropagation();
            props.options.paste(undefined, "", true);
        } else if (option === "Rename") {
            e.stopPropagation();
            handleCloseRename();
            // const n = item?.library_label?.includes('CUSTOM') ? item.action_name : t(`CONTENT.LIBRARY.${item.libraryName}.ACTION.${item.name}`);
            // props.options.rename(n);
        } else if (option === "Disable") {
            e.stopPropagation();
            setAlert(alert => ({ ...alert, show: true, message: t("MESSAGES.AUTOMS.ACTION-DISABLED"), severity: 'success' }))
            props.options.disable();
        }
        if (option !== "Rename") {
            handleClose();
        }
        // handleClose(); // close
    };
    const getStyle = () => {
        let style = { top: 0, right: -3 }
        if (item.action_name === 'CONDITION') {
            return { ...style, right: -7 };
        }
        return style;
    }
    return (
        <>
            <IconButton className="option-icon"
                style={{ position: 'absolute', zIndex: 9999, ...getStyle() }}
                onClick={handleClick}
                size="small"
            >
                <MoreVertIcon fontSize="small" />
            </IconButton>
            <Menu
                style={{ zIndex: 99999999 }}
                id="long-menu"
                anchorEl={anchorEl}
                keepMounted
                open={open}
                onClose={handleClose}
                PaperProps={{
                }}
            >
                {Object.keys(options).map((option) =>
                    item.actionName === 'START' ? option === 'Paste' && <MenuItem
                        key={option}
                        style={{ color: "#212F3B", fontSize: "10px", fontWeight: 600 }}
                        onClick={(e) => menu(option, e)}
                    >
                        {options[option]}
                        {option}
                    </MenuItem> :
                        !isCondition ? (
                            option !== "Paste Inside" ? option === "OpenTab" ? (
                                setDetailTabs &&
                                <MenuItem
                                    key={option}
                                    style={{ color: "#212F3B", fontSize: "10px", fontWeight: 600 }}
                                    onClick={(e) => menu(option, e)}
                                >
                                    {options[option]}
                                    {option}
                                </MenuItem>) : (
                                <MenuItem
                                    key={option}
                                    style={{ color: "#212F3B", fontSize: "10px", fontWeight: 600 }}
                                    onClick={(e) => menu(option, e)}
                                >
                                    {options[option]}
                                    {option}
                                </MenuItem>
                            ) : null
                        ) :
                            option === "OpenTab" ? (
                                setDetailTabs &&
                                <MenuItem
                                    key={option}
                                    style={{ color: "#212F3B", fontSize: "10px", fontWeight: 600 }}
                                    onClick={(e) => menu(option, e)}
                                >
                                    {options[option]}
                                    {option}
                                </MenuItem>) : (
                                ((!item.libraryName && option !== "Rename") || item.libraryName) &&
                                <MenuItem
                                    key={option}
                                    style={{ color: "#212F3B", fontSize: "10px", fontWeight: 600 }}
                                    onClick={(e) => menu(option, e)}
                                >
                                    {options[option]}
                                    {option}
                                </MenuItem>
                            )
                )}
            </Menu>
        </>
    );
}

export default OptionsMenu;
